import { useCallback } from 'react';
import { useEnvironment, useHttp } from '@publicisgroupe/p-os-components';
import { PageInfoDto } from 'types/PageInfoDto';
import {
  getHelpSectionFromConfigApi,
  getHelpSectionFromSharepointApi,
} from 'components/HelpSection/helpers';
import { SharepointEntities } from 'utils/enums';

export const usePageInfoData = () => {
  const http = useHttp();
  const env = useEnvironment();

  return useCallback(
    async (useConfigModule: boolean) => {
      const responsePageInfoData = useConfigModule
        ? await getHelpSectionFromConfigApi(http, 'HelpSectionConfig')
        : await getHelpSectionFromSharepointApi(env, SharepointEntities.HelpSection);

      if (!responsePageInfoData?.length) return;

      return useConfigModule
        ? responsePageInfoData
        : responsePageInfoData.map(
            (pageInfo: any) =>
              ({
                title: pageInfo.Title,
                freetextbox: pageInfo.Freetextbox,
                headerLogo: pageInfo.HeaderLogo,
                imageContainer: [],
                learnaboutPGOS: pageInfo.LearnaboutPGOS,
                module: pageInfo.Modul?.Value ?? '',
                protipbox: pageInfo.Protipbox,
                textBox: pageInfo.TextBox,
                contentImage: pageInfo.ContentImage,
                imageText: pageInfo.ImageText,
                pageURL: pageInfo.PageURL,
              } as PageInfoDto)
          );
    },
    [http, env]
  );
};
